import React, { useRef } from "react";
import { Box, Typography, Divider } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { DetailsPopover } from "../detailsPopover";
import useStyles from "./NotificationsBar.styles";

interface NotificationDetailsPopoverProps {
    anchorElHover: HTMLElement | null;
    hoveredNotification: any;
    handlePaperEnter: () => void;
    handlePaperLeave: () => void;
    getNotificationText: (item: any) => string;
}

export const NotificationDetailsPopover: React.FC<NotificationDetailsPopoverProps> = ({
    anchorElHover,
    hoveredNotification,
    handlePaperEnter,
    handlePaperLeave,
    getNotificationText
}) => {
    const classes = useStyles();
    return (
        <DetailsPopover
            isPopoverOpen={Boolean(anchorElHover)}
            anchorEl={anchorElHover}
            title={hoveredNotification?.notification?.title || "Notification"}
            items={
                <div 
                    className={classes.popoverContent}
                    dangerouslySetInnerHTML={{ 
                        __html: hoveredNotification?.notification?.body || getNotificationText(hoveredNotification) 
                    }} 
                />
            }
            actions={{
                paperEnter: handlePaperEnter,
                popoverLeave: handlePaperLeave
            }}
            maxWidth={400}
        />
    );
};
